export class Supervisor {
  constructor ({
    id,
    cpf,
    rg,
    nome,
    email,
    data_nascimento,
    sexo,
    telefones,
    gestor_id,
    unidades,
    role,
    tipo_supervisor,
    tecnicos,
    status,
  } = {
      id: '',
      cpf: '',
      rg: '',
      role: '',
      nome: '',
      email: '',
      data_nascimento: '',
      sexo: '',
      gestor_id: '',
      unidades: [],
      telefones: [],
      tipo_supervisor: null,
      tecnicos: [],
      status: '',
    }) {
    this.id = id
    this.cpf = cpf
    this.rg = rg
    this.nome = nome
    this.email = email
    this.data_nascimento = data_nascimento
    this.sexo = sexo
    this.telefones = telefones
    this.role = role
    this.gestor_id = gestor_id
    this.unidades = unidades
    this.tipo_supervisor = tipo_supervisor
    this.tecnicos = tecnicos
    this.status = status
  }
}

export function createSupervisor (data) {
  return Object.freeze(new Supervisor(data))
}
